export const SHOTS_PER_DAY = 7;
export const ZONES_COUNT = 6;
/**
 * A keeper zone is "frequently defended" (gets the truth-reveal danger ring)
 * when its true share is >= 20% above the uniform per-zone baseline.
 * Derived from ZONES_COUNT so it stays correct if the zone count ever changes.
 * For 6 zones this is 0.20 (uniform baseline is 1/6 ≈ 0.1667).
 */
export const DANGER_ZONE_THRESHOLD = 1.2 / ZONES_COUNT;
export const SCHEMA_VERSION = 2;

/**
 * Mood-shift Δ per difficulty tier — the SINGLE compile-time tuning seam.
 *
 * Δ-TUNING CONTRACT (spec §4.4, decision D3 — read before changing these):
 * - Δ is GLOBAL PER DATE: every player on date D shifts identically. Δ is read
 *   only via `resolveMoodDelta(tier)` (src/lib/game-mode.ts). Do NOT read this
 *   map anywhere else, and do NOT add a runtime override.
 * - Δ is COMPILE-TIME ONLY. To retune you must edit the numbers HERE, then
 *   rebuild + redeploy. A runtime KV/D1 Δ source is REJECTED: a non-atomic
 *   propagation across a cohort mid-day is a seed-divergence failure mode.
 * - Δ IS NOT THE E[score] KNOB. For a best-response player (aims at the keeper's
 *   lowest-probability zone), the SHIPPED rule makes raising Δ *lower* E[score]:
 *   a bigger Δ sharpens the keeper's peak (applyMoodShift piles the drained mass
 *   onto the just-attacked zone), so the player's aim scatter (aimToZone +
 *   OFF_FRAME_FLOOR) is punished harder (measured DIVER ~6.33 at Δ=0 → ~5.29 at
 *   Δ=0.9). This is the OPPOSITE of spec D3's stated sign (which holds only for an
 *   idealized perfect-aim player) — a KNOWN DESIGN FINDING under review: Δ may be
 *   punishing skill, counter to the anti-frustration intent. Revisit the keeper
 *   rule before re-adding a directionality gate (see the Δ-tuning runbook). Either
 *   way Δ is the WRONG lever for the community median; the REAL E[score] lever is
 *   OFF_FRAME_FLOOR (src/lib/swipe-math.ts:26). Adjust OFF_FRAME_FLOOR FIRST;
 *   touch Δ only if a specific tier needs reshaping.
 * - Retune procedure: docs/superpowers/specs/2026-05-30-napi-11es-delta-tuning-runbook.md
 */
export const MOOD_DELTA_BY_TIER: Record<1 | 2 | 3, number> = {
  1: 0.10,
  2: 0.20,
  3: 0.30,
};
